import { isLoadingOrNull, JcLoading, JC_LOADING } from "jcsdk";
import { makeJcAuth } from "jcfirebase";
import { jcalAuthService } from "src/services/auth/JCalAuthService";

export const {
    AuthProvider: JCalAuthProvider,
    useAuthState: useJCalAuthState,
    RequireAuth: JCalAuthGuard,
} = makeJcAuth(jcalAuthService);

/** Whether the viewer can edit projects; `JC_LOADING` until auth resolves. */
export const useJCalIsAdmin = (): boolean | JcLoading => {
    const auth = useJCalAuthState();
    if (auth === JC_LOADING) {
        return JC_LOADING;
    }
    return !isLoadingOrNull(auth) && auth.isAdmin;
};
